// extracted by mini-css-extract-plugin
export default {"root":"SubEmpty_root__9WEB4","add":"SubEmpty_add__RhXmV"};